import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import { ConfigProvider } from 'antd';

import zhTW from 'antd/lib/locale/zh_TW';  // 繁体中文语言包
import zhCN from 'antd/lib/locale/zh_CN'; // 简体中文语言包
import enUS from 'antd/lib/locale/en_US'; // 英文语言包
// import 'moment/locale/zh-cn';
import 'antd/dist/antd.css';//antd样式导入

import Main from './system/main/main';
import Page404 from './system/404/404';
import Login from './system/login/login';
import LoginBack from './system/login/loginBack';

import ForgotUserID from './website/forgotUserID/forgotUserID';
import ForgotPassword from './website/forgotPassword/forgotPassword';
import Help from './website/help/help';
import { Config } from './public/js/config';
import { Base } from './public/js/base';

import './index.css';

import moment from 'moment';//日期格式化导包
import 'moment/locale/zh-cn';
import IndexAbout from './website/indexAbout/indexAbout';
moment.locale('en-au');

export default class Root extends Component {

  constructor() {
    super();

    // let backLang = localStorage.getItem('wilBackLang');
    // if(!backLang){
    //   if (window.location.href.indexOf('lang=') > 0) {
    //     let strList = window.location.href.split('lang=');
    //     Config.backLang = strList[1].toUpperCase();
    //   } else {
    //     Config.backLang = 'SC';
    //   }
    //   localStorage.setItem("wilBackLang", Config.backLang);
    // }else{
    //   Config.backLang = backLang;
    // }

    // 獲取訪問設備信息
    this.getEquipmentInfo();
    Config.equipmentInfo.type = Base.getEquipmentType();
  }

  /**访问设备equipmentInfo */
  getEquipmentInfo() {
    if (Base.cgIsEnd()) {
      /**移动端 */
      Config.equipmentInfo.name = Base.cgIsPhone();
    } else {
      /**pc端 */
      Config.equipmentInfo.name = Base.cgIsView();
    }
    /**微信 */
    if (Base.cgIsWeixn()) {
      Config.equipmentInfo.isWx = true;
    } else {
      Config.equipmentInfo.isWx = false;
    }
  }

  render() {

    // const routePathMain = props => {
    //   let obj = Object.assign({}, {}, props)
    //   return <Main {...obj} />
    // }

    return (
      <ConfigProvider locale={Config.backLang == 'SC' ? zhCN : (Config.backLang === 'TC' ? zhTW : enUS)}>
        <Router>
          <Switch>
            <Route key='/' path="/" exact component={Login} />
            <Route key='login' path="/login" component={Login} />
            <Route key='forgotUserID' path="/forgotUserID" component={ForgotUserID} />
            <Route key='forgotPassword' path="/forgotPassword" component={ForgotPassword} />
            <Route key='help' path="/help" component={Help} />
            <Route key='indexAbout' path="/indexAbout" component={IndexAbout} />
            <Route key='main' path="/main" component={Main} />
            {/* <Route key='loginBack' path="/loginBack" component={LoginBack} /> */}
            <Route component={Page404} />
          </Switch>
        </Router>
      </ConfigProvider>
    );
  }

}

ReactDOM.render(<Root />, document.getElementById('root'));

serviceWorker.unregister();
